<template>
<common-dialog
  :show.sync="visible"
  :title="'上传护照自动识别'"
  :showFooter="false"
  class="created-on-job-dialog"
>
  <div class="dialog-body" >
    <div class="step-box">
      <div class="step-item">
        <img src="../../../assets/imgs/on-job/step-1.png" class="item-img" alt="">
        <div class="item-text">上传护照</div>
      </div>
      <div class="step-item">
        <img src="../../../assets/imgs/on-job/step-2.png" class="item-img" alt="">
        <div class="item-text">自动识别</div>
      </div>
      <div class="step-item">
        <img src="../../../assets/imgs/on-job/step-3.png" class="item-img" alt="">
        <div class="item-text">填写信息</div>
      </div>
      <div class="step-item">
        <img src="../../../assets/imgs/on-job/step-4.png" class="item-img" alt="">
        <div class="item-text">智能生成</div>
      </div>
    </div>
    <div class="example-box">
      <div class="example-img-box">
        <img src="../../../assets/imgs/on-job/example-img.png" class="example-img" alt="">
      </div>
      <div class="check-info">
        <div class="check-item">
          <img src="../../../assets/imgs/on-job/icon-selected.png" class="item-icon" alt="">
          <div class="item-text">上传清晰的护照首页</div>
        </div>
        <div class="check-item">
          <img src="../../../assets/imgs/on-job/icon-selected.png" class="item-icon" alt="">
          <div class="item-text">彩色扫描件或手机拍照(JPG/PNG)</div>
        </div>
        <div class="check-item">
          <img src="../../../assets/imgs/on-job/icon-selected.png" class="item-icon" alt="">
          <div class="item-text">露出四个边角，拍照不要反光</div>
        </div>
      </div>
    </div>
    <div class="btn-box">
      <input type="file" class="faraway" accept="image/png, image/jpeg" multiple="multiple" ref="batchUploadFiles" @change="startUpload">
      <input type="file" class="faraway" accept="image/png, image/jpeg" ref="uploadFile" @change="startUpload">

      <el-button class="s-btn btn-lg btn-blue is-plain" :loading="loading" @click="selectFile('batch')">批量上传(10张)</el-button>
      <el-button class="s-btn btn-lg btn-blue" :loading="loading" @click="selectFile">上传护照</el-button>
    </div>
  </div>
</common-dialog>
</template>

<script>
import sensorsdata from 'sa-sdk-javascript';
import User from '../../../libs/user.js';
import CommonDialog from '../../../components/common/modals/common-dialog/common-dialog.vue';
import uploadFileService from '../../../services/upload-file-service.js';
import Http from '../../../libs/http';

export default {
  components: {
    CommonDialog,
  },
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      visible: this.show,
      loading: false,
    };
  },
  watch: {
    visible(newValue) {
      this.$emit('update:show', newValue);
    },
    show(val) {
      this.visible = val;
    },
  },
  methods: {
    selectFile(type) {
      if (type === 'batch') {
        sensorsdata.track('On_the_job_bulk_upload', {
          peer_name: User.peer.peer_name,
          visa_peer_id: User.peer.visa_peer_id,
        });
        this.$refs.batchUploadFiles.click();
      } else {
        sensorsdata.track('On_the_job_upload', {
          peer_name: User.peer.peer_name,
          visa_peer_id: User.peer.visa_peer_id,
        });
        this.$refs.uploadFile.click();
      }
    },
    startUpload(e) {
      const files = e.target.files;
      if (!(files && files.length > 0)) return;
      // 先判断一次上传的文件数量
      if (files.length > 10) {
        this.$message.error('单次上传护照数最多10张，请重新选择上传');
        e.target.value = '';
        return;
      }

      // 将选择的文件列表转为数组
      const filesArray = Array.from(files);

      // 上传前校验文件类型
      const typeError = filesArray.find(el => ['image/jpeg', 'image/png'].indexOf(el.type) === -1);
      if (typeError) {
        this.$message.error('护照识别失败，请检查后重新上传');
        e.target.value = '';
        return;
      }

      if (this.loading) {
        e.target.value = '';
        return;
      }
      this.loading = true;

      const uploadPromise = [];

      // 识别护照
      filesArray.forEach((file) => {
        uploadPromise.push(
          uploadFileService.uploadOcrMaterial(file, 'passport', { noToast: true, zipImg: true }),
        );
      });
      Promise.all(uploadPromise).then((res) => {
        // 识别成功
        this.loading = false;
        e.target.value = '';
        // 存在不是护照
        const someNotPassport = res.some(item => !item.passport_number);
        if (someNotPassport) {
          this.$message.error('护照识别失败，请检查后重新上传');
        } else {
          this.createdOnJob(res);
        }
      }).catch(() => {
        this.$message.error('护照识别失败，请检查后重新上传');
        this.loading = false;
        e.target.value = '';
      });
    },
    createdOnJob(passportList) {
      const onjob_list = passportList.map(item => ({
        passport_content: {
          passport_num: item.passport_number || '',
          surname_cn: item.surname_cn || '',
          surname_pinyin: item.surname_pinyin || '',
          name_cn: item.name_cn || '',
          name_pinyin: item.name_pinyin || '',
          birthday: item.birthday || '',
          sex: [0, 1].indexOf(item.gender) > -1 ? item.gender : '',
          key: item.temp_key || '',
        },
      }));
      Http.post('/archives_onjob_add', {
        onjob_list,
      }).then((res) => {
        this.visible = false;
        this.$router.push({
          name: 'EditOnJob',
          query: {
            id_list: encodeURIComponent(JSON.stringify(res.archives_onjob_id_set)),
            type: 'add',
          },
        });
      });
    },

  },
};
</script>

<style lang="less" scoped>
.created-on-job-dialog{
   /deep/ .el-dialog{
    width: 600px;
    .el-dialog__header{
      justify-content: center;
    }
  }
  .dialog-body{
    padding: 24px;
    .step-box{
      width: 100%;
      height: 53px;
      background: #F9FCFF;
      border-radius: 1px;
      border: 1px solid #D3E5FF;
      display: flex;
      align-items: center;
      justify-content: center;
      .step-item{
        margin-right: 52px;
        display: flex;
        align-items: center;
        position: relative;
        .item-img{
          width: 28px;
          height: 28px;
        }
        .item-text{
          color: #2F333D;
          font-size: 14px;
          margin-left: 3px;
        }
        &::after{
          content: "";
          width: 22px;
          height: 6px;
          background: url(../../../assets/imgs/on-job/step-arrow.png) no-repeat center / 100% 100%;
          position: absolute;
          left: 100%;
          top: 50%;
          margin-left: 16px;
          transform: translateY(-50%);
        }
        &:last-child{
          margin-right: 0;
          &::after{
            display: none;
          }
        }
      }
    }
    .example-box{
      margin-top: 24px;
      display: flex;
      .example-img-box{
        font-size: 0;
        flex-shrink: 0;
        margin-right: 24px;
        .example-img{
          width: 258px;
          height: 170px;
        }
      }
      .check-info{
        flex-grow: 1;
        overflow: hidden;
        padding-top: 12px;
        .check-item{
          display: flex;
          align-items: flex-start;
          margin-bottom: 24px;
          &:last-child{
            margin-bottom: 0;
          }
          .item-icon{
            width: 16px;
            height: 16px;
            margin-right: 4px;
            margin-top: 3px;
          }
          .item-text{
            color: #2F333D;
            font-size: 16px;
            line-height: 22px;
          }
        }
      }
    }
    .btn-box{
      margin-top: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      .s-btn{
        width: 146px;
        padding: 0;
      }
      .s-btn + .s-btn{
        margin-left: 16px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/on-job/components/created-on-job-dialog.vue